module.exports = __webpack_public_path__ + "img/BN_1920X960.adea26ac.png";